var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('custom-table',{attrs:{"index":"","data":_vm.data,"tableCode":_vm.tableCode,"column":_vm.tableColumn,"filterArr":['action']},on:{"input":_vm.selectionChange,"filter":_vm.filterChange,"sort":_vm.sortChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }